document.addEventListener('DOMContentLoaded', function () {
  init();
});

const init = () => {
  setVisibleBlocks();

  let filterButtons = document.querySelectorAll('.press-room-listing .filter-button');

  filterButtons.forEach((filterButton) => {
    filterButton.addEventListener('click', (event) => {
      setActiveButton(filterButtons, event);
      filterBlocks(event);
    });
  });

  if (window.location.hash) {
    window.scrollTo(0, 0);

    [...filterButtons].find((filterButton) => {
      if (filterButton.id === window.location.hash.replace('#', '')) {
        filterButton.click();
      }
    });
  }

  document.querySelector('.show-more-btn').addEventListener('click', () => {
    setVisibleBlocks(window.location.hash.replace('#', ''));
  });

  document.querySelector('.show-all-btn').addEventListener('click', () => {
    showAllBlocks(window.location.hash.replace('#', ''));
  });
};

const setActiveButton = (filterButtons, event) => {
  filterButtons.forEach((filterButton) => {
    filterButton.classList.remove('active');
    filterButton.setAttribute('aria-pressed', 'false');
  });

  event.target.classList.add('active');
  event.target.setAttribute('aria-pressed', 'true');

  if (event.target.id !== 'all') window.history.replaceState(undefined, undefined, `#${event.target.id}`);
  else window.history.replaceState(undefined, undefined, ' ');
};

const filterBlocks = (event) => {
  var filterId = event.target.id;

  let blocks = document.querySelectorAll('.pressroom-content-block');
  blocks.forEach((block) => {
    block.classList.add('d-none');
  });
  setVisibleBlocks(event.target.id === 'all' ? null : filterId);
};

const setVisibleBlocks = (filter) => {
  const increment = 12;
  let blocks = Array.from(document.querySelectorAll('.pressroom-content-block'));
  if (filter) {
    blocks = blocks.filter((x) => x.dataset.tagId === filter);
  }
  Array.from(document.querySelectorAll('.total-blocks')).forEach((number) => {
    number.innerHTML = blocks.length;
  });
  const visibleBlocks = blocks.filter((x) => !x.classList.contains('d-none'));
  const amountVisible = visibleBlocks.length;
  const showMoreBtnSection = document.querySelector('.show-more-btn-section');
  if (amountVisible + increment < blocks.length) {
    showMoreBtnSection.classList.remove('d-none');
  } else {
    showMoreBtnSection.classList.add('d-none');
  }
  document.querySelector('.amount-of-blocks-visible').innerHTML =
    amountVisible + increment > blocks.length ? blocks.length : amountVisible + increment;
  let blocksToShow = blocks.splice(amountVisible, increment);
  blocksToShow.forEach((block) => {
    block.classList.remove('d-none');
  });
};

const showAllBlocks = (filter) => {
  let blocks = Array.from(document.querySelectorAll('.pressroom-content-block'));
  if (filter) {
    blocks = blocks.filter((x) => x.dataset.tagId === filter);
  }
  blocks.forEach((block) => {
    block.classList.remove('d-none');
  });
  document.querySelector('.show-more-btn-section').classList.add('d-none');
  document.querySelector('.amount-of-blocks-visible').innerHTML = blocks.length;
};

//TODO - sorting
// const menu = document.querySelector('.filter-menu.left-slide-in-menu');
// const filterCloseBtns = document.querySelectorAll('.close-btn');
// const filterMenuBtn = document.querySelector('.toggle-filter-menu');

// filterMenuBtn.addEventListener('click', function () {
//   menu.classList.add('wrapper-visible');
//   document.querySelector('html').classList.add('no-scroll');
//   document.querySelector('body').classList.add('no-scroll');
// });

// filterCloseBtns.forEach((btn) => {
//   btn.addEventListener('click', function () {
//     menu.classList.remove('wrapper-visible');
//     document.querySelector('html').classList.remove('no-scroll');
//     document.querySelector('body').classList.remove('no-scroll');
//   });
// });

// const sortRadioButtons = document.querySelectorAll('input[type="radio"]');
// sortRadioButtons.forEach((option) => {
//   option.addEventListener('change', (e) => {
//     if (window.innerWidth < 992) {
//       sortBlocks(e.target.value);
//     }
//   });
// });

// const sortBlocks = () => {
//   let blocks = Array.from(document.querySelectorAll('.pressroom-content-block'));
//   let container = document.querySelector('.blocks');
//   let newHtml = '';
//   let sortedBlocks = blocks.reverse();
//   sortedBlocks.forEach((block) => {
//     newHtml += block.outerHTML;
//   });
//   container.innerHTML = newHtml;
// };
